import { render } from "./PolicyDetails.vue?vue&type=template&id=682edc78&scoped=true&ts=true"
import script from "./PolicyDetails.vue?vue&type=script&lang=ts"
export * from "./PolicyDetails.vue?vue&type=script&lang=ts"

import "./PolicyDetails.vue?vue&type=style&index=0&id=682edc78&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-682edc78"]])

export default __exports__